import theme from '@docpocalypse/code-live/themes/oceanicNext';
export default theme;